import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { formatDate } from "../../../utils/datetime";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";

const useStyles = makeStyles(theme => ({
  filter: {
    margin: theme.spacing(1, 3, 1, 0),
    maxHeight: theme.spacing(4),
    background: theme.palette.common.white
  }
}));

const DateFilter = ({ column: { filterPlaceholder, setFilter } }) => {
  const classes = useStyles();
  const [value, setValue] = useState(null);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        value={value}
        clearable
        onChange={date => {
          setValue(date);
          // Only changes the filter if the date is valid or empty
          if (moment(date).isValid()) {
            setFilter(formatDate(date, "DD/MM/YYYY"));
          } else if (!date) {
            setFilter(null);
          }
        }}
        error={null}
        helperText={null}
        renderInput={params => (
          <TextField
            variant="filled"
            disableUnderline
            {...params}
            InputProps={{
              disableUnderline: true,
              sx: {
                pr: 0
              },
              className: classes.filter,
              hiddenLabel: true,
              ...params.InputProps
            }}
            inputProps={{
              ...params.inputProps,
              "data-qa": "date-filter-input",
              placeholder: filterPlaceholder
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DateFilter;
